import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AssessmentCategoriesWrapper from "Settings/components/AssessmentCategoriesWrapper";
import GradeBoundariesWrapper from "Settings/components/GradeBoundariesWrapper";
import MYPCriteriaConfiguration from "Settings/components/MYPCriteriaConfiguration";
import GradingConfigurations from "LearningCourse/routes/CourseSettings/routes/GradingConfigurations";
import GradingVisibility from "LearningCourse/routes/CourseSettings/routes/GradingVisibility";

export default store => ({
  path: ":subjectId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "subject" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    MYPCriteriaConfiguration(store),
    AssessmentCategoriesWrapper(store),
    GradeBoundariesWrapper(store),
    GradingConfigurations(store),
    GradingVisibility(store),
  ],
});
